module.exports = __webpack_public_path__ + "static/media/cwiczenie_10.f958c248.jpg";